import { Component, OnInit, Input } from '@angular/core';
import { StateProvinceService } from '../shared/state-province/state-province.service';
import { StateProvince } from '../shared/state-province/state-province.model';
import { StringValueAccessor, CreateStringValueAccessorProvider } from '../../shared/widgets/value-accessors/string-value-accessor';

@Component({
  selector: 'wl-state-selector',
  templateUrl: 'state-selector.component.html',
  styleUrls: ['state-selector.component.css'],
  providers: [CreateStringValueAccessorProvider(StateSelectorComponent)],
  standalone: false
})
export class StateSelectorComponent extends StringValueAccessor implements OnInit {
  @Input() public displayAbbreviation: boolean = true;
  @Input() public disabled: boolean = false;

  public _stateProvinceService: StateProvinceService;
  public stateAndProvinces: Array<StateProvince>;

  private _selectedStateProvince: StateProvince;
  public constructor(stateProvinceService: StateProvinceService) {
    super();
    this._stateProvinceService = stateProvinceService;
    this.stateAndProvinces = new Array<StateProvince>();
  }

  /*
   * override the base writeValue method because we need to set the initial value if its passed in from a binding
   */
  writeValue(value: string) {
    this._value = value;
    this._selectedStateProvince = this.stateAndProvinces.find((x) => x.Abbreviation === this.value);
    if(this._selectedStateProvince === undefined){
      this._selectedStateProvince = new StateProvince()
      this._selectedStateProvince.Abbreviation = value
      this._selectedStateProvince.Name = value
    }
    this.onChange(value);
  }

  ngOnInit() {
    this._stateProvinceService.getUsStatesAndCanadianProvinces().then((data: Array<StateProvince>) => {
      this.stateAndProvinces = data;
    });
  }

  get selectedStateProvince() {
    return this._selectedStateProvince;
  }
  set selectedStateProvince(value:StateProvince) {
    if(value.Abbreviation === undefined){
      this.value = value.toString()
    }else{
      this.value = value.Abbreviation;
    }
    this._selectedStateProvince = value;
  }
}
